(() => {
  if (window.__ecomhardVariantPickerLoaded) return;
  window.__ecomhardVariantPickerLoaded = true;

  const SELECT_SIZE_TEXT = 'Selecione o tamanho';
  const SELECT_SIZE_BUTTON_TEXT = 'SELECIONE O TAMANHO';

  function getSizeFieldsets(productInfo) {
    return Array.from(productInfo.querySelectorAll('[data-ecomhard-size-option="true"]'));
  }

  function setInitialSizeState(productInfo) {
    if (!productInfo || productInfo.dataset.ecomhardSizePickerInitialized === 'true') return;

    const sizeFieldsets = getSizeFieldsets(productInfo);
    if (!sizeFieldsets.length) return;

    productInfo.dataset.ecomhardSizePickerInitialized = 'true';
    productInfo.classList.add('ecomhard-size-selection-required');

    sizeFieldsets.forEach((fieldset) => {
      fieldset.querySelectorAll('input.product-option__input[type="radio"]').forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
      });

      const selectedValue = fieldset.querySelector('[data-selected-value]');
      if (selectedValue) selectedValue.textContent = SELECT_SIZE_TEXT;
    });

    /* Remove o ID padrão da primeira variante do formulário até que o cliente escolha o tamanho. */
    productInfo.querySelectorAll('product-form input.product-variant-id[name="id"]').forEach((variantInput) => {
      variantInput.value = '';
    });

    const submitButton = productInfo.querySelector('product-form .product-form__submit[type="submit"]');
    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      const text = submitButton.querySelector('span');
      if (text) text.textContent = SELECT_SIZE_BUTTON_TEXT;
    }
  }

  function initialize(root = document) {
    if (root.matches?.('product-info')) setInitialSizeState(root);
    root.querySelectorAll?.('product-info').forEach(setInitialSizeState);
  }

  /*
   * O tema troca o ID oculto da variante somente depois de resolver a combinação
   * selecionada. Mantemos o bloqueio até esse momento para não liberar a compra cedo.
   */
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('input.product-variant-id[name="id"]')) return;
    const variantInput = event.target;
    if (!variantInput.value) return;

    const productInfo = variantInput.closest('product-info');
    if (!productInfo || !getSizeFieldsets(productInfo).length) return;

    productInfo.classList.remove('ecomhard-size-selection-required');
  });

  document.addEventListener('product-info:loaded', (event) => {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();
